<template>
  <section>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition>
          <v-btn
            color="secondary"
            fab
            fixed
            large
            dark
            @click="getDefaultChatMessagesAndCategories(mainPartner)"
            v-bind="attrs"
            v-on="on"
            bottom
            right
          >
            <v-badge
              v-if="$store.getters.getBadgeInfo > 0"
              color="red"
              :content="$store.getters.getBadgeInfo"
            >
              <v-icon class="secondary-font-color">chat</v-icon>
            </v-badge>
            <v-icon class="secondary-font-color" v-else>chat</v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
      <span>Open chats</span>
    </v-tooltip>

    <v-dialog
      transition="dialog-bottom-transition"
      fullscreen
      hide-overlay
      v-model="chatDialogOpen"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn class="mr-4" icon dark @click="chatDialogOpen = false">
            <v-icon>remove</v-icon>
          </v-btn>
          {{ $translate('YOUR_CHAT_WITH') }} {{ mainPartner.Name }}
        </v-toolbar>
        <chat-bubble
          v-if="chatDialogOpen"
          :selectedPartner="mainPartner"
          :currentChat="selectedChat"
          :categories="defaultCategories"
          @getMessagesForUser="getMessagesForUser"
        />
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import doRequest from '@/api/dssRequest';
import UserJS from '@/objects/UserObject';
import ChatBubble from '@/components/chats/ChatBubble';

export default {
  name: 'Chat',
  components: {
    ChatBubble,
  },
  computed: {
    partnerGroupDetails() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    userLoggedIn() {
      const userValid = this.$store.getters['auth/isValid'];
      if (userValid) {
        return true;
      }
      return false;
    },
    mainPartner() {
      const pgDetails = this.$store.getters['Account/partnerGroupDetails'];
      if (pgDetails == null || pgDetails.Partners == null) {
        return {};
      }

      const result = pgDetails.Partners.find((partner) => partner.MainPartner);

      if (result == null) {
        return {};
      }

      return result;
    },
  },
  data() {
    return {
      // Chats
      allMessages: [],
      chatDialogOpen: false,
      defaultCategories: [],
      selectedChat: {},
    };
  },
  mounted() {
    // UserJS.getMessagesForUser();
    this.getMessagesForUser();
  },
  methods: {
    getMessages() {},
    getMessagesForUser(partner) {
      if (!this.userLoggedIn) {
        return;
      }

      // Get all the chat messages from the MessageSearchEngine
      const payload = {};
      doRequest(
        (response) => {
          this.allMessages = response.data.Messages;

          if (partner) {
            this.selectedChat = {};
            response.data.Messages.forEach((chat) => {
              if (
                chat.PeerId === `${partner.AccountId}_UG_${partner.PartnerId}`
              ) {
                this.selectedChat = chat;
                setTimeout(() => {
                  this.$store.commit(
                    'setBadgeInfo',
                    this.$store.getters.getBadgeInfo -
                      this.selectedChat.UnreadMessages
                  );
                  this.selectedChat.UnreadMessages = 0;
                  chat.UnreadMessages = 0;
                  this.markMessagesAsRead(partner);
                }, 2000);
              }
            });
            this.chatDialogOpen = true;
          } else {
            let unreadMessages = 0;
            response.data.Messages.forEach((chat) => {
              unreadMessages += chat.UnreadMessages;
            });
            this.$store.commit('setBadgeInfo', unreadMessages);
          }
        },
        () => {},
        'getMessagesForUser',
        'LocationsNode_MSE',
        payload
      );
    },
    markMessagesAsRead(partner) {
      // Mark all messages within the chat as read
      const payload = {};

      doRequest(
        () => {
          this.selectedChat.Messages.forEach((message) => {
            if (message.PeerUserId !== '' && !message.Read) {
              message.Read = true;
            }
          });
          let newBadgeAmount = 0;
          newBadgeAmount =
            this.$store.getters.getBadgeInfo - this.selectedChat.UnreadMessages;
          this.$store.commit('setBadgeInfo', newBadgeAmount);
          this.selectedChat.UnreadMessages = 0;
        },
        () => {},
        'markMessageAsRead',
        `${partner.AccountId}_UG_${partner.PartnerId}`,
        payload
      );
    },
    getDefaultChatMessagesAndCategories(partner) {
      // Check if user is logged in
      if (!this.$store.getters['auth/isValid']) {
        window.EventBus.fire('triggerOpenAccountFromMenu', {
          toggle: true,
          component: 'Login',
        });
        return;
      }

      // Get all the default chat messages and categories from the MessageSearchEngine
      const payload = {
        PartnerId: partner.PartnerId,
      };

      doRequest(
        (response) => {
          this.defaultCategories = [];
          this.defaultCategories = response.data.Categories;
          this.getMessagesForUser(partner);
        },
        () => {},
        'getDefaultChatMessagesAndCategories',
        'LocationsNode_MSE',
        payload
      );
    },
  },
};
</script>
